import { render, staticRenderFns } from "./IndexActionNeeded.vue?vue&type=template&id=a33b98f8"
import script from "./IndexActionNeeded.vue?vue&type=script&lang=js"
export * from "./IndexActionNeeded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports